import enumeration from "./enumeration";

const EndOfDayReportStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
};

export default enumeration(EndOfDayReportStatus);
